import prefill from '../prefill';
import sets from '../sets';

export default prefill({
  0: {},
  1: {},
  2: { price: 2, set: sets.baseHair1 },
  3: {},
  4: { price: 2, set: sets.baseHair1 },
  5: { price: 2, set: sets.baseHair1 },
  6: { price: 2, set: sets.baseHair1 },
  7: { price: 2, set: sets.baseHair1 },
  8: { price: 2, set: sets.baseHair1 },
  9: { price: 2, set: sets.baseHair2 },
  10: { price: 2, set: sets.baseHair2 },
  11: { price: 2, set: sets.baseHair2 },
  12: { price: 2, set: sets.baseHair2 },
  13: { price: 2, set: sets.baseHair2 },
  14: { price: 2, set: sets.baseHair2 },
  15: { price: 2, set: sets.baseHair3 },
  16: { price: 2, set: sets.baseHair3 },
  17: { price: 2, set: sets.baseHair3 },
  18: { price: 2, set: sets.baseHair3 },
  19: { price: 2, set: sets.baseHair3 },
  20: { price: 2, set: sets.baseHair3 },
});
